/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIRequestSearchResult } from './APIRequestSearchResult';
import {
    APIRequestSearchResultFromJSON,
    APIRequestSearchResultFromJSONTyped,
    APIRequestSearchResultToJSON,
} from './APIRequestSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIRequestSearchResponse
 */
export interface APIRequestSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APIRequestSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APIRequestSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APIRequestSearchResult>}
     * @memberof APIRequestSearchResponse
     */
    results: Array<APIRequestSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APIRequestSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APIRequestSearchResponse interface.
 */
export function instanceOfAPIRequestSearchResponse(value: object): value is APIRequestSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APIRequestSearchResponseFromJSON(json: any): APIRequestSearchResponse {
    return APIRequestSearchResponseFromJSONTyped(json, false);
}

export function APIRequestSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRequestSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APIRequestSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APIRequestSearchResponseToJSON(value?: APIRequestSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APIRequestSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

